import React, {Component} from 'react';
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {FormGroup} from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import FormField from "../../../../../../Utils/Form/Fields/FormField";
import ListDesignerHoc from "../../../../../../HocHelpers/ListDesignerHoc";
import {valueHandlerDefault} from "../../../../../../Utils/Form/FormDynamic/Utils/valueHandler";
import SelectType from "../../../../../../Utils/Form/FormDynamic/Fields/SelectType/Select";
import {multiLanguageValue} from "../../../../../JsonScreen/Utils/lib";
import TypeEntity from "../../../../../../Utils/Form/FormDynamic/Fields/EntityExternal/Entity";

const styles = () => ({
    wrapper: {
        display: 'flex',
        padding: "15px 0 0 20px"
    },
    label: {
        fontSize: '0.9rem'
    },
    tableWrapper: {
        width: '100%',
        borderSpacing: 0,
        border: '1px solid #fff',
        borderCollapse: 'collapse'
    },
    tableCellLabel: {
        paddingLeft: 10,
        minWidth: '150px',
        border: '1px solid',
        borderColor: '#ebebeb'
    },
    tableCell: {
        minWidth: '100px',
        border: '1px solid',
        borderColor: '#ebebeb'
    }
});


class GridForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fields: {
                hideListHeader: {
                    name: "hideListHeader",
                    label: "Hide Header",
                    path: "gridProps.hideListHeader",
                    type: "checkbox",
                },
                hideListFooter: {
                    name: "hideListFooter",
                    label: "Hide Footer",
                    path: "gridProps.hideListFooter",
                    type: "checkbox",
                },
                hideColumnHeader: {
                    name: "hideColumnHeader",
                    label: "Hide Columns",
                    path: "gridProps.hideColumnHeader",
                    type: "checkbox",
                },
                hideLabel: {
                    name: "hideLabel",
                    label: "Hide Label",
                    path: "gridProps.hideLabel",
                    type: "checkbox",
                },
                hideQuickSearch: {
                    name: "hideQuickSearch",
                    label: "Hide Quick Search",
                    path: "gridProps.hideQuickSearch",
                    type: "checkbox",
                },
                hideAdvancedSearch: {
                    name: "hideAdvancedSearch",
                    label: "Hide Advanced Search",
                    path: "gridProps.hideAdvancedSearch",
                    type: "checkbox",
                },
                sortable: {
                    name: "sortable",
                    label: "Sortable",
                    path: "gridProps.sortable",
                    type: "checkbox",
                },
                selectable: {
                    name: "selectable",
                    label: "Selectable",
                    path: "gridProps.selectable",
                    type: "checkbox",
                },
                exportable: {
                    name: 'exportable',
                    label: 'Exportable',
                    path: 'gridProps.exportable',
                    type: 'checkbox'
                },
                altExport: {
                    name: 'altExport',
                    label: 'Alternative Export',
                    path: 'gridProps.altExport',
                    type: 'checkbox'
                },
                columnsSelect: {
                    name: 'columnsSelect',
                    label: 'Columns Select',
                    path: 'gridProps.columnsSelect',
                    type: 'checkbox'
                },
                showCountSelected: {
                    name: "showCountSelected",
                    label: "Show Count Selected",
                    path: "gridProps.showCountSelected",
                    type: "checkbox",
                },
                ignoreCount: {
                    name: 'ignoreCount',
                    label: "Don't count documents",
                    path: "gridProps.ignoreCount",
                    type: 'checkbox'
                },
                noWrap: {
                    name: 'noWrap',
                    label: "No Wrap Labels",
                    path: "gridProps.noWrap",
                    type: 'checkbox'
                },
                sumSelectedFields: {
                    name: "sumSelectedFields",
                    label: "Sum Selected Fields",
                    path: "gridProps.sumSelectedFields",
                    type: "autocomplete",
                },
                selectedField: {
                    name: "selectedField",
                    label: "Selected Field",
                    path: "gridProps.selectedField",
                    type: "string",
                },
                layoutType: {
                    name: "layoutType",
                    label: "Layout Type",
                    path: "gridProps.layoutType",
                    type: "select",
                    menu: [{value: 'auto', label: 'Auto'}, {value: 'fixed', label: 'Fixed'}]
                },
                altExportScreen: {
                    name: 'altExportScreen',
                    label: 'Export Screen',
                    path: 'gridProps.altExportScreen',
                    type: 'autocomplete',
                    source: 'screen'
                },
            }
        }
    }

    gridForm = () => {
        const {fields} = this.state;
        const {
            classes,
            data,
            gridChange,
            gridChangeSumSelectedFields,
            pivotGeneratedColumns,
            userLanguage
        } = this.props;
        let showCountSelected = valueHandlerDefault(data, fields.showCountSelected.path);
        let showSelectedField = valueHandlerDefault(data, fields.selectable.path);
        let isAltExport = valueHandlerDefault(data, fields.altExport.path);
        let columnsSuggestions = (pivotGeneratedColumns && pivotGeneratedColumns.length > 0) ? pivotGeneratedColumns : data.columns || [];
        let newColumns = columnsSuggestions
            .filter(f => f.type === 'number' || f.type === 'integer')
            .map(el => {
                return {label: multiLanguageValue(el.label, userLanguage), value: el.name}
            });
        return (
            <>
                <div className={classes.wrapper}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">View Settings</FormLabel>
                        <FormGroup>
                            <FormField field={fields.hideListHeader}
                                       values={data}
                                       onChange={gridChange}
                                       path={fields.hideListHeader.path}/>

                            <FormField field={fields.hideColumnHeader}
                                       values={data}
                                       onChange={gridChange}
                                       path={fields.hideColumnHeader.path}/>

                            <FormField field={fields.hideLabel}
                                       values={data}
                                       onChange={gridChange}
                                       path={fields.hideLabel.path}/>

                            <FormField field={fields.hideQuickSearch}
                                       values={data}
                                       onChange={gridChange}
                                       path={fields.hideQuickSearch.path}/>

                            <FormField field={fields.hideAdvancedSearch}
                                       values={data}
                                       onChange={gridChange}
                                       path={fields.hideAdvancedSearch.path}/>

                            <FormField field={fields.hideListFooter}
                                       values={data}
                                       onChange={gridChange}
                                       path={fields.hideListFooter.path}/>
                            <FormField field={fields.noWrap}
                                       values={data}
                                       onChange={gridChange}
                                       path={fields.noWrap.path}/>
                        </FormGroup>
                    </FormControl>
                    <FormControl>
                        <FormLabel>Other Settings</FormLabel>
                        <FormGroup>
                            <FormField field={fields.sortable}
                                       values={data}
                                       onChange={gridChange}
                                       path={fields.sortable.path}/>
                            <FormField field={fields.selectable}
                                       values={data}
                                       onChange={gridChange}
                                       path={fields.selectable.path}/>
                            <FormField field={fields.exportable}
                                       values={data}
                                       onChange={gridChange}
                                       path={fields.exportable.path}/>
                            <FormField field={fields.altExport}
                                       values={data}
                                       onChange={gridChange}
                                       path={fields.altExport.path}/>
                            <FormField field={fields.showCountSelected}
                                       values={data}
                                       onChange={gridChange}
                                       path={fields.showCountSelected.path}/>
                            <FormField field={fields.ignoreCount}
                                       values={data}
                                       onChange={gridChange}
                                       path={fields.ignoreCount.path}/>
                            <FormField field={fields.columnsSelect}
                                       values={data}
                                       onChange={gridChange}
                                       path={fields.columnsSelect.path}/>
                        </FormGroup>
                    </FormControl>
                </div>

                <table className={classes.tableWrapper}>
                    <tbody>
                    <tr>
                        <td className={classes.tableCellLabel}>{fields.layoutType.label}</td>
                        <td className={classes.tableCell}>
                            <SelectType
                                field={{
                                    type: "objSelect",
                                    optLabel: "label",
                                    path: fields.layoutType.path,
                                    values: fields.layoutType.menu,
                                    isArray: false
                                }}
                                values={data}
                                showLabel={false}
                                fieldStyles={{withoutStyles: true}}
                                setValue={gridChangeSumSelectedFields}
                            />
                            {/*<FormField*/}
                            {/*    onChange={gridChange}*/}
                            {/*    values={data}*/}
                            {/*    defaultValue={'auto'}*/}
                            {/*    path={fields.layoutType.path}*/}
                            {/*    field={fields.layoutType}*/}
                            {/*/>*/}
                        </td>
                    </tr>
                    </tbody>
                </table>

                {showCountSelected && (
                    <table className={classes.tableWrapper}>
                        <tbody>
                        <tr>
                            <td className={classes.tableCellLabel}>{fields.sumSelectedFields.label}</td>
                            <td className={classes.tableCell}>
                                <SelectType
                                    field={{
                                        type: "objSelect",
                                        optLabel: "label",
                                        path: fields.sumSelectedFields.path,
                                        values: newColumns,
                                        isArray: true
                                    }}
                                    values={data}
                                    showLabel={false}
                                    fieldStyles={{withoutStyles: true}}
                                    setValue={gridChangeSumSelectedFields}
                                />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                )}
                {showSelectedField && (
                    <table className={classes.tableWrapper}>
                        <tbody>
                        <tr>
                            <td className={classes.tableCellLabel}>{fields.selectedField.label}</td>
                            <td className={classes.tableCell}>
                                <FormField field={fields.selectedField}
                                           values={data}
                                           onChange={gridChange}
                                           path={fields.selectedField.path}/>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                )}
                {isAltExport && (
                    <table className={classes.tableWrapper}>
                        <tbody>
                        <tr>
                            <td className={classes.tableCellLabel}>{fields.altExportScreen.label}</td>
                            <td className={classes.tableCell}>
                                <TypeEntity
                                    field={{
                                        path: fields.altExportScreen.path,
                                        isArray: false,
                                        entity: 'screen'
                                    }}
                                    values={data}
                                    showLabel={false}
                                    fieldStyles={{withoutStyles: true, fullWidth: true}}
                                    setValue={(value) => {
                                        gridChange({target: {name: 'altExportScreen', value}})
                                    }}
                                />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                )}
            </>
        )
    };

    render() {
        return (
            this.gridForm()
        )
    }
}

export default ListDesignerHoc(withStyles(styles)(GridForm));